module.exports = __webpack_public_path__ + "static/rightsidebar-skeleton-a91497a38beb6948a486f9d67a13000c.jpg";